import { envSettings } from "core/EnvSettings";
import React from "react";

import { operationModeToggleEnum } from "./OperationModeToggleFilter";
import { ReserveCheckbox } from "./ReserveCheckbox";

export const ReservePalletButton = ({
	orderId,
	record,
	selectedPalletsUI,
	onClick,
	updateRecordsOnPalletSelection,
	isSelectedViewMode,
	operationMode,
}) => {
	// pallet checked if it's selected in UI (reserved)
	const isPalletChecked = (pallet) => !!selectedPalletsUI[pallet.id];
	const isPalletReservedForAnotherOrder =
		record.reserved_order_id && record.reserved_order_id !== orderId;
	const isPalletLoadedOrMoved = record.loaded_into_truck || record.into_preparation_place;
	const isAutoReservedEmptyPallet = record.reserved_order_id === orderId && record.quantity === 0;

	const disabled =
		isPalletReservedForAnotherOrder ||
		isSelectedViewMode ||
		(!envSettings.REACT_APP_FF_COMBINED_SCANNER_MANUAL_MODE && operationMode === operationModeToggleEnum[0].value) ||
		!record.is_storage_place_confirmed ||
		isPalletLoadedOrMoved ||
		isAutoReservedEmptyPallet;
	const handleChange = (event) => {
		onClick(record);
		updateRecordsOnPalletSelection(record.id, event.target.checked);
	};

	return (
		<ReserveCheckbox
			checked={isPalletChecked(record)}
			disabled={disabled}
			onChange={handleChange}
		/>
	);
};
